import { defineTheme } from '../contract';
import './styles.css';

export default defineTheme({
  id: 'minimal',
  name: 'Minimal',
  description: 'Paper white, ink black. Subtle word feedback, no audio.',
});
